module.exports = "https://img.zhijierongxing.com/saas/img/check_icon.718a04ab.png";